import React from "react"
import { LockIcon } from "../../../components/icons"
import { Button, ButtonProps } from "../../../vanilla"
import { useBasketStore } from "../../../store/hooks/useStore"
import { useAlcoholRestrictions } from "../../../hooks/use-alcohol-restrictions"

interface CheckoutButtonProps extends ButtonProps {
    checkoutButtonText: string
}

export const BasketToCheckoutButton = React.forwardRef((props: CheckoutButtonProps, ref: React.Ref<any>) => {
    const {checkoutButtonText, ...rest } = props
    const {basket, hasAlcoholItems, basketMinDeliveryThreshold, basketLimitThreshold} = useBasketStore()
    const { progress } = basketLimitThreshold ?? {}
    const {isCurrentSlotAlcoholRestricted} = useAlcoholRestrictions()
    const restrictedByAlcohol = isCurrentSlotAlcoholRestricted && hasAlcoholItems
    const isOverLimit = !!progress && progress > 100
    const isDisabled = restrictedByAlcohol || (basket?.productTotal || 0) < (basketMinDeliveryThreshold || 0) || isOverLimit
    return (
        <Button
            size="sm"
            variant="primary"
            gap="12px"
            alignItems="center"
            iconRight={<LockIcon boxSize="12px" />}
            disabled={isDisabled}
            {...rest}
            ref={ref}
        >
            {checkoutButtonText}
        </Button>
    )
})